
import inputSelect from '../multipleSelectCheckboxV2'

const commonMultipleSelectCheckboxV2 = {
    install:function(Vue) {
        Vue.component('commonMultipleSelectCheckboxV2', inputSelect)
    }
}


// 导出该组件

export default commonMultipleSelectCheckboxV2